export const spribeData = {
  spribe1: {
    redirectUrl: "/casino/aggapspribe-mines",
    imgUrl: "./images/spribe/Mines.jpg",
    name: "Mines",
  },
  spribe2: {
    redirectUrl: "/casino/aggapspribe-goal",
    imgUrl: "./images/spribe/Goal.jpg",
    name: "Goal",
  },
  spribe3: {
    redirectUrl: "/casino/aggapspribe-dice",
    imgUrl: "./images/spribe/Dice.jpg",
    name: "Dice",
  },
  spribe4: {
    redirectUrl: "/casino/aggapspribe-aviator",
    imgUrl: "./images/spribe/Aviator.jpg",
    name: "Aviator",
  },
  spribe5: {
    redirectUrl: "/casino/aggapspribe-plinko",
    imgUrl: "./images/spribe/Plinko.jpg",
    name: "Plinko",
  },
  spribe6: {
    redirectUrl: "/casino/aggapspribe-miniroulette",
    imgUrl: "./images/spribe/MiniROulette.jpg",
    name: "Mini Roulette",
  },
  spribe7: {
    redirectUrl: "/casino/aggapspribe-hilo",
    imgUrl: "./images/spribe/Hilonew.jpg",
    name: " Hilo",
  },
};
